export const assetContracts = [
  {
    number: "VDA-000151",
    customer: "Carlos Almeida",
    type: "Venda parcelada de veículo",
    asset: "Chevrolet Onix 2022",
    status: "ACTIVE",
    updatedAt: "19/09/2026",
  },
  {
    number: "LOC-I-000041",
    customer: "Mariana Costa",
    type: "Locação de imóvel",
    asset: "Apartamento Centro",
    status: "ACTIVE",
    updatedAt: "18/09/2026",
  },
  {
    number: "LOC-V-000030",
    customer: "João Ferreira",
    type: "Locação de veículo",
    asset: "Renault Kwid 2023",
    status: "ACTIVE",
    updatedAt: "18/09/2026",
  },
];

export const assetCustomers = [
  {
    id: "counterparty-1",
    name: "Carlos Almeida",
    documentType: "CPF",
    document: "***.***.***-82",
    contact: "(41) 9****-0182",
    activeAgreements: 1,
    relationship: "Comprador de veículo",
    openBalance: "R$ 34.000,00",
    status: "ACTIVE",
  },
  {
    id: "counterparty-2",
    name: "Mariana Costa",
    documentType: "CPF",
    document: "***.***.***-40",
    contact: "(41) 9****-7740",
    activeAgreements: 1,
    relationship: "Locatária de imóvel",
    openBalance: "R$ 1.850,00",
    status: "ACTIVE",
  },
  {
    id: "counterparty-3",
    name: "Comercial Sul Ltda.",
    documentType: "CNPJ",
    document: "**.***.***/****-19",
    contact: "(41) 3***-2119",
    activeAgreements: 1,
    relationship: "Locatária de imóvel",
    openBalance: "R$ 3.264,00",
    status: "OVERDUE",
  },
  {
    id: "counterparty-4",
    name: "João Ferreira",
    documentType: "CPF",
    document: "***.***.***-51",
    contact: "(41) 9****-9051",
    activeAgreements: 1,
    relationship: "Motorista locatário",
    openBalance: "R$ 650,00",
    status: "ACTIVE",
  },
];

export const assetDashboardMetrics = [
  { label: "Vendas parceladas", value: "150", delta: "Carteira estimada" },
  { label: "Imóveis alugados", value: "40", delta: "Contratos recorrentes" },
  { label: "Veículos locados", value: "30", delta: "Motoristas de aplicativo" },
  { label: "Recebíveis em aberto", value: "R$ 1,24 mi", delta: "Dados demonstrativos" },
  { label: "Vencido", value: "R$ 86,4 mil", delta: "6,9% da carteira" },
  { label: "Ativos cadastrados", value: "220", delta: "Veículos + imóveis" },
];

export const assets = [
  {
    id: "asset-vehicle-1",
    code: "VEI-000151",
    type: "VEHICLE",
    name: "Chevrolet Onix 1.0",
    description: "2022 · Branco · placa ***1A23",
    status: "SOLD",
    value: "R$ 58.000,00",
  },
  {
    id: "asset-vehicle-2",
    code: "VEI-000181",
    type: "VEHICLE",
    name: "Renault Kwid Zen",
    description: "2023 · Prata · placa ***8B71",
    status: "RENTED",
    value: "R$ 54.900,00",
  },
  {
    id: "asset-property-1",
    code: "IMO-000041",
    type: "PROPERTY",
    name: "Apartamento Centro",
    description: "2 quartos · 1 vaga · Curitiba/PR",
    status: "LEASED",
    value: "R$ 320.000,00",
  },
  {
    id: "asset-property-2",
    code: "IMO-000042",
    type: "PROPERTY",
    name: "Sala Comercial Norte",
    description: "85 m² · Curitiba/PR",
    status: "AVAILABLE",
    value: "R$ 280.000,00",
  },
];

export const vehicleSales = [
  {
    id: "sale-vehicle-1",
    number: "VDA-000151",
    customer: "Carlos Almeida",
    vehicle: "Chevrolet Onix 2022",
    mode: "INSTALLMENT",
    total: "R$ 58.000,00",
    downPayment: "R$ 10.000,00",
    installments: "24",
    status: "ACTIVE",
    transfer: "IN_PROGRESS",
  },
  {
    id: "sale-vehicle-2",
    number: "VDA-000150",
    customer: "Empresa Exemplo Ltda.",
    vehicle: "Fiat Argo 2021",
    mode: "CASH",
    total: "R$ 52.000,00",
    downPayment: "R$ 52.000,00",
    installments: "1",
    status: "COMPLETED",
    transfer: "COMPLETED",
  },
];

export const propertyLeases = [
  {
    id: "lease-property-1",
    number: "LOC-I-000041",
    tenant: "Mariana Costa",
    property: "Apartamento Centro",
    monthlyRent: "R$ 1.850,00",
    dueDay: "10",
    startsAt: "01/08/2026",
    endsAt: "31/07/2027",
    status: "ACTIVE",
  },
  {
    id: "lease-property-2",
    number: "LOC-I-000039",
    tenant: "Comercial Sul Ltda.",
    property: "Sala Comercial Sul",
    monthlyRent: "R$ 3.200,00",
    dueDay: "05",
    startsAt: "01/03/2026",
    endsAt: "28/02/2027",
    status: "OVERDUE",
  },
];

export const vehicleRentals = [
  {
    id: "rental-vehicle-1",
    number: "LOC-V-000030",
    driver: "João Ferreira",
    vehicle: "Renault Kwid 2023",
    frequency: "WEEKLY",
    rent: "R$ 650,00",
    dueDay: "Toda segunda",
    mileage: "43.280 km",
    status: "ACTIVE",
  },
  {
    id: "rental-vehicle-2",
    number: "LOC-V-000028",
    driver: "Pedro Santos",
    vehicle: "Hyundai HB20 2022",
    frequency: "WEEKLY",
    rent: "R$ 680,00",
    dueDay: "Toda sexta",
    mileage: "58.912 km",
    status: "OVERDUE",
  },
];

export const assetReceivables = [
  {
    id: "installment-1",
    customer: "Carlos Almeida",
    agreement: "VDA-000151",
    asset: "Chevrolet Onix 2022",
    sequence: "8/24",
    dueDate: "10/09/2026",
    original: "R$ 2.000,00",
    updated: "R$ 2.046,00",
    daysLate: 10,
    status: "OVERDUE",
  },
  {
    id: "installment-2",
    customer: "Mariana Costa",
    agreement: "LOC-I-000041",
    asset: "Apartamento Centro",
    sequence: "2",
    dueDate: "10/10/2026",
    original: "R$ 1.850,00",
    updated: "R$ 1.850,00",
    daysLate: 0,
    status: "OPEN",
  },
  {
    id: "installment-3",
    customer: "João Ferreira",
    agreement: "LOC-V-000030",
    asset: "Renault Kwid 2023",
    sequence: "12",
    dueDate: "21/09/2026",
    original: "R$ 650,00",
    updated: "R$ 650,00",
    daysLate: 0,
    status: "OPEN",
  },
];

export const publicPaymentReceivables = [
  {
    installmentId: "installment-1",
    agreementNumber: "VDA-000151",
    agreementType: "VEHICLE_SALE",
    assetName: "Chevrolet Onix 2022",
    sequence: 8,
    dueDate: "2026-09-10",
    originalAmountCents: "200000",
    paidAmountCents: "0",
    status: "OVERDUE",
    daysLate: 10,
    lateFeeCents: "4000",
    interestCents: "600",
    correctionCents: "0",
    updatedAmountCents: "204600",
  },
  {
    installmentId: "installment-2",
    agreementNumber: "LOC-I-000041",
    agreementType: "PROPERTY_LEASE",
    assetName: "Apartamento Centro",
    sequence: 2,
    dueDate: "2026-10-10",
    originalAmountCents: "185000",
    paidAmountCents: "0",
    status: "OPEN",
    daysLate: 0,
    lateFeeCents: "0",
    interestCents: "0",
    correctionCents: "0",
    updatedAmountCents: "185000",
  },
];
